import { Arg, Metadata } from '../../../../utils/spds/metadata';
import CTA from './footer/cta.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import styles from './footer.module.scss';

export const ALIGN_ITEMS_DEFAULT = 'center';
export const JUSTIFY_CONTENT_DEFAULT = 'space-between';

const METADATA = Metadata.define({
  description: 'Footer for full-screen modal with optional CTA.',
  meta: {
    backBtnAction: Arg.action({ description: 'Action for back button' }),
    currentStep: Arg.number({ description: 'Current step for back button visibility' }),
    primaryBtnAction: Arg.action({ description: 'Action for primary button' }),
    primaryBtnDisabled: Arg.boolean({ default: false }),
    primaryBtnText: Arg.string({
      description: 'Label for primary button',
      initialValue: 'Next step',
    }),
    secondaryBtnAction: Arg.action({ description: 'Action for secondary button' }),
    secondaryBtnDisabled: Arg.boolean({ default: false }),
    secondaryBtnText: Arg.string({
      description: 'Label for secondary button',
      initialValue: 'Back',
    }),
  },
  name: 'Footer',
});

export default class SpdsModalFullScreenFooter extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-full-screen-footer';
  styles = styles;

  get alignItems() {
    return this.args.alignItems ?? ALIGN_ITEMS_DEFAULT;
  }

  get justifyContent() {
    return this.args.justifyContent ?? JUSTIFY_CONTENT_DEFAULT;
  }

  <template>
    <FlexRow
      @alignItems={{this.alignItems}}
      @justifyContent={{this.justifyContent}}
      @tag="footer"
      class={{this.classes}}
      data-test-spds-modal-full-screen-footer
      {{this.validateArguments}}
      ...attributes
    >
      {{#if (has-block "footer-cta")}}
        {{yield to="footer-cta"}}
      {{else}}
        <CTA
          @backBtnAction={{@backBtnAction}}
          @currentStep={{@currentStep}}
          @primaryBtnAction={{@primaryBtnAction}}
          @primaryBtnText={{@primaryBtnText}}
          @primaryBtnDisabled={{@primaryBtnDisabled}}
          @secondaryBtnAction={{@secondaryBtnAction}}
          @secondaryBtnText={{@secondaryBtnText}}
          @secondaryBtnDisabled={{@secondaryBtnDisabled}}
        />
      {{/if}}
    </FlexRow>
  </template>
}

export const MODAL_FULL_SCREEN_FOOTER_METADATA = SpdsModalFullScreenFooter.metadata;
